import React from "react";
import { OptionType } from "../../common/store";

export default function({options, value, onChange, className, placeholder}:{options:any[], value:string|undefined, onChange: Function, className?:string, placeholder?:string}){

    return(
        <select  placeholder={placeholder} name="" id="" value={value} className={className} onChange={(e) => {onChange(e)}} >
            {
                options.sort((a,b)=> Number.parseInt(a.value) > Number.parseInt(b.value) ? 1 : Number.parseInt(a.value) === Number.parseInt(b.value) ? 0 : -1).map((e:OptionType) => (
                <option value={e.value} label={e.label} key={Math.random()}></option>
                ))
            }
        </select>
    )
}